import { render, staticRenderFns } from "./CohortDetail.vue?vue&type=template&id=1ade1a30&"
import script from "./CohortDetail.vue?vue&type=script&lang=js&"
export * from "./CohortDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports